import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { dependencies as realDependencies, Dependencies } from '../dependencies'
import { ccamCategorylabelsReducer } from './reducers/ccamCategoryLabels.reducer'
import { ccamCodesReducer } from './reducers/ccamCodes.reducer'
import { commonCaresReducer } from './reducers/commonCares.reducer'
import { simulationReducer } from './reducers/simulation.reducer'
import { simulationResultReducer } from './reducers/simulationResult.reducer'
import { lexicalCodesReducer } from './reducers/lexicalCodes.reducer'

const rootReducer = combineReducers({
  ccamCategoryLabels: ccamCategorylabelsReducer,
  ccamCodes: ccamCodesReducer,
  simulation: simulationReducer,
  commonCares: commonCaresReducer,
  simulationResult: simulationResultReducer,
  lexicalCodes: lexicalCodesReducer,
})

export function createStore({
  initialState = {},
  dependencies,
}: {
  initialState?: Partial<ReturnType<typeof rootReducer>>
  dependencies: Dependencies
}) {
  return configureStore({
    devTools: process.env.NODE_ENV === 'development',
    preloadedState: initialState ?? undefined,
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: dependencies,
        },
        serializableCheck: false,
      }),
  })
}

export const store = createStore({ dependencies: realDependencies })
export type AppState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector = <T = unknown>(selector: (state: AppState) => T) =>
  useSelector<AppState, T>(selector)
export type ReduxStore = typeof store

export type ThunkConfig = {
  dispatch: AppDispatch
  state: AppState
  extra: Dependencies
}
